<template>
  <router-view />
</template>

<script>
import { jwtDecode } from "jwt-decode";
import { v4 as uuidv4 } from 'uuid';
import platform from "platform"
export default {
  computed: {
    uuid() {
      if(localStorage.getItem("device_id")){
        return localStorage.getItem("device_id")
      }
      return uuidv4()
    },
    platformName() {
      return `${platform.name}/${platform.os?.family}`
    }
  },
  mounted () {
    console.log({nav: window.navigator, uuid: uuidv4()})
    window.onload = () => {
      console.log("INITIALIZE", {google: window.google})
      window.google.accounts.id.initialize({
        client_id: process.env.VUE_APP_GCID,
        callback: this.handleCredentialResponse
      });
      this.$store.dispatch("setIsGoogleInit", true)
    };
  },
  methods: {
    async handleCredentialResponse(response) {
      console.log("ENCODED JWT ID Token", {response})
      const userObj = jwtDecode(response.credential)
      console.log({userObj})
      this.$store.dispatch("setGoogleUser", userObj)
      localStorage.setItem("gsic", response.credential);
      try {
        await this.$store.dispatch("googleLogin", {
          client_id : process.env.VUE_APP_GCID,
          jwt_token: response.credential,
          device_info: {
            id: this.uuid,
            name: this.platformName
          }
        })
      } catch (error) {
          let msg= "Something Went Wrong"
          if (error?.response?.data?.code_message) {
            msg = error.response.data.code_message
          }
          this.$swal({
            icon: "error",
            title: "Login Failed",
            text: msg,
            showConfirmButton: false,
            timer: 2500,
          });
      }

      this.$router.push({
        name: "Home",
      });
    },
  }
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200;400;500;700&family=Roboto:ital,wght@0,100;0,500;0,700;1,300;1,400&display=swap');

.table > :not(caption) > * > * {
  background-color: transparent !important;
}
html {
  font-size: 0.7rem;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.swal2-container {
  z-index: 1160 !important;
}

.font-gbook {
  font-family: "gotham book";
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.w-10 {
  width: 10% !important;
}

.fsize-8 {
  font-size: 8px;
}
.fsize-10 {
  font-size: 10px;
}
.fsize-12 {
  font-size: 12px !important;
}
.fsize-14 {
  font-size: 14px;
}
.fsize-16 {
  font-size: 16px;
}
.fsize-18 {
  font-size: 18px;
}
.fsize-20 {
  font-size: 20px;
}
.fsize-22 {
  font-size: 22px;
}
.fsize-24 {
  font-size: 24px;
}
.fsize-32 {
  font-size: 32px;
}
.full-width {
  width: 100%;
}
.router-link-active {
  text-decoration: none;
  color: black;
}
</style>
